import {fmonetary} from '@eitje/utils'
import {formatNumber} from '@eitje/web_components/src/components/graph/helpers'

const formatFullMonetary = value => fmonetary(value, {decimals: 2})
const formatCompactMonetary = value => fmonetary(value, {decimals: 0})
const formatCompactNumber = value => formatNumber(Math.round(value))

export const graphVariantsTaxonomy = [
	{
		name: 'amt',
		fullFormatFn: formatFullMonetary,
		compactFormatFn: formatCompactMonetary,
	},
	{
		name: 'amt_users',
		fullFormatFn: formatNumber,
		compactFormatFn: formatCompactNumber,
	},
	{
		name: 'amt_envs',
		fullFormatFn: formatNumber,
		compactFormatFn: formatCompactNumber,
	},
	{
		name: 'euro_per_env',
		fullFormatFn: formatFullMonetary,
		compactFormatFn: formatCompactMonetary,
		accessorFn: row => row.amt / row.amt_envs,
	},
	{
		name: 'user_per_env',
		fullFormatFn: formatNumber,
		compactFormatFn: formatCompactNumber,
		accessorFn: row => row.amt_users / row.amt_envs,
	},
	{
		name: 'euro_per_user',
		fullFormatFn: formatFullMonetary,
		compactFormatFn: formatCompactMonetary,
		accessorFn: row => row.amt / row.amt_users,
	},
]
